/**
 * マッチング設定 作成/編集ページ コンテナ
 */
import type React from "react";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  type CreateMatchingSettingInput,
  useCreateMatchingSetting,
  useMatchingSetting,
  useUpdateMatchingSetting,
} from "../../../hooks/use-matching-settings-api";
import { MatchingSettingFormPage } from "./MatchingSettingFormPage";

const MatchingSettingFormPageContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEdit = !!id;

  const { setting, loading } = useMatchingSetting(id);
  const { createSetting, loading: isCreating } = useCreateMatchingSetting();
  const { updateSetting, loading: isUpdating } = useUpdateMatchingSetting();

  const handleSubmit = useCallback(
    async (input: CreateMatchingSettingInput) => {
      if (isEdit && id) {
        await updateSetting(id, input);
      } else {
        await createSetting(input);
      }
      navigate("/settings/matching/conditions");
    },
    [isEdit, id, createSetting, updateSetting, navigate],
  );

  return (
    <MatchingSettingFormPage
      isEdit={isEdit}
      initialData={setting}
      loading={isEdit && loading}
      onSubmit={handleSubmit}
      isSubmitting={isCreating || isUpdating}
    />
  );
};

export default MatchingSettingFormPageContainer;
